import React from 'react';
import { Text } from '..';
import styles from './date-picker.module.css';
import { useCalendarManager } from './useCalendarManager';
export const SelectedDate = () => {
    const { format, userSelectedDate } = useCalendarManager();
    return (React.createElement(Text, { className: styles.weekLabel }, format(userSelectedDate)));
};
